import { Option } from "@inrev/core";
import { DateTime } from "luxon";
import { type FC } from "react";
import { calculateDelta } from "../calculateDelta";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { getEquityFYEValue } from "../utils/financialMetricValues";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type EquityFYECardProps = {
	recentFYE?: FinancialPeriodBundle;
	previousFYE?: FinancialPeriodBundle;
};

export const EquityFYECard: FC<EquityFYECardProps> = ({ recentFYE, previousFYE }) => {
	const periodEndDate = recentFYE?.period?.periodEndDate;
	const recentYear = Option.map(periodEndDate, (date) => DateTime.fromISO(date).toFormat("yy"));
	const label = `Equity (FYE${recentYear ? ` '${recentYear}` : ""})`;

	const recentEquity = recentFYE?.balanceSheet?.view?.equity.total.allowed;
	const previousEquity = previousFYE?.balanceSheet?.view?.equity.total.allowed;

	const value = getEquityFYEValue(recentFYE);
	const delta = Option.doWith(
		{ recentEquity, previousEquity },
		({ recentEquity, previousEquity }) => calculateDelta(recentEquity, previousEquity),
	);

	return <FinancialMetricCard testId="equity-fye-card" label={label} value={value} delta={delta} />;
};
